import React from 'react'

import DashboardLayout from '../DashboardLayout'
import Layout from '../Layout'
import SellerDashboard from '../../../utils/CommonFunctionality/SellerDashboard'

const SellerDashboardOverview = (props) => {
    return (
        <Layout>
            <DashboardLayout title="Dashboard" subtitle="Items" seller>
                <div className="db-bids-wrapper mb-4">
                    <SellerDashboard />
                </div>
            </DashboardLayout>
        </Layout>
    )
}

export default SellerDashboardOverview
